import React, {useEffect, useState} from 'react';
import StartAffirmButton from './StartAffirmButton';
import SaveCartButton from './SaveCartButton';
import PaypalCheckoutButton from './PaypalCheckoutButton';
import {applePayAvailable} from "../../services/applePayHelpers";
import {getEnabledPaymentTypes} from "../../services/cartConfig";
import AlternatePayment from "./AlternatePayment";
import ApplePayButton from "../../../Checkout/components/payment/ApplePayButton";
import PrimaryCheckoutButton from "./PrimaryCheckoutButton";
import {isCheckoutDisabled} from "../../../Checkout/logic/checkout";
import {useNonEmptyContext} from "../../../lib/hooks";
import {CartConfigContext} from "../../../contexts/CartConfigContext";

export default function CartSidebarButtonBox({
  braintreeClient,
  cartCode,
  shoppingCart = {},
  currentAgent,
  enableAffirm = false
}) {
  const cartConfig = useNonEmptyContext(CartConfigContext);

  const [applePayExists, setApplePayExists] = useState(false);

  // Safely detect if apple pay exists on this machine
  useEffect(() => {
    setApplePayExists(applePayAvailable())
  }, []);

  let ptList = getEnabledPaymentTypes({
    shoppingCart, currentAgent, cartConfig
  });

  const paymentTypes = _.keyBy(ptList, x => x);

  const checkoutDisabled = isCheckoutDisabled(cartConfig);

  return (<div id="cart-sidebar-button-box">
    <SaveCartButton shoppingCart={shoppingCart}/>

    {!checkoutDisabled && <PrimaryCheckoutButton
      shoppingCart={shoppingCart}
      cartCode={cartCode}
      />}

    {!checkoutDisabled && <div id="other-checkouts">
      <AlternatePayment visible={paymentTypes['affirm'] && enableAffirm}>
        <StartAffirmButton shoppingCart={shoppingCart}/>
      </AlternatePayment>

      <AlternatePayment visible={applePayExists && paymentTypes['apple']}>
        <ApplePayButton shoppingCart={shoppingCart} braintreeClient={braintreeClient}/>
      </AlternatePayment>

      <AlternatePayment visible={paymentTypes['paypal']}>
        <PaypalCheckoutButton cartCode={cartCode} shoppingCart={shoppingCart}/>
      </AlternatePayment>
    </div>}
  </div>);
}

